//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/popup'
import 'devextreme/ui/tabs'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ConfigurationProfileFunctionModel, ScheduleConfigurationModel } from '../../api/api.models'
import { i18n } from '../i18n/common.i18n'
import { EventsNames } from '../../../helpers/events-names'
import { Permissions } from '../../../helpers/permissions'
import { TabsData } from '../../common/common.interfaces'
import { TemplateHelper, ConfigHelper, LocalizationHelper } from '../../../helpers'

//#region Asset Imports

import './device-configuration.scss'
import * as TEMPLATE from './device-configuration.tpl.html'

//#endregion

interface DeviceConfigurationScope extends ng.IScope {
    id: any
    tabs: TabsData

    popupOptions: DevExpress.ui.dxPopupOptions
    popupVisible: boolean
    title: string

    configList: DevExpress.ui.dxListOptions
    selectedConfigItem: any[]
    selectedConfig: string
    idConfigurationProfile: number
    profileFunctionsList: ConfigurationProfileFunctionModel[]
}

export class DeviceConfigurationDirective implements ng.IDirective {
    constructor() { }

    restrict = 'E'
    scope = {
        id: '='
    }
    template = TEMPLATE

    private configList: DevExpress.ui.dxList

    private permissions: any[]
    private tabs: { template: string, name: string }[]

    controller = ['$scope', '$q', '$element', 'api', 'logger', 'localDictionary', '$timeout', ($scope: DeviceConfigurationScope, $q: ng.IQService, $element: JQuery, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, $timeout: ng.ITimeoutService) => {
        $scope.popupVisible = false
        $scope.tabs = <TabsData>{}
        $scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible'
            },
            fullScreen: true,
            title: i18n('Common', 'ConfigurationProfileEdit'),
            onHiding: () => { $scope.popupVisible = false }
        }

        if (!$scope.tabs.selectedTab) {
            $scope.tabs.selectedTab = 0
        }

        var getTabs = () => {
            var [SCHEDULE_LIST, ALARM_LIST] = this.permissions
            var tabs = []
            if (SCHEDULE_LIST) tabs.push({ template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Schedule), ConfigHelper.Icon.SCHEDULE), name: 'schedule' })
            if (ALARM_LIST) tabs.push({ template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Alarms), ConfigHelper.Icon.ALARMS), name: 'alarms' })
            return tabs
        }

        var getSelectedTabName = () => {
            return this.tabs[$scope.tabs.selectedTab] ? this.tabs[$scope.tabs.selectedTab].name : ''
        }

        var configureTabs = (tabs: { template: string, name: string }[]) => {
            if ($scope.tabs.selectedTab >= tabs.length) $scope.tabs.selectedTab = tabs.length - 1
            this.tabs = tabs
            $scope.tabs.selectedTabName = getSelectedTabName()
            $scope.tabs.visible = this.tabs.length > 1
            $scope.tabs.tabsOptions = {
                dataSource: tabs,
                bindingOptions: {
                    selectedIndex: 'tabs.selectedTab',
                    visible: 'tabs.visible'
                },
                onSelectionChanged: (e) => {
                    $timeout(() => {
                        $scope.tabs.selectedTabName = getSelectedTabName()
                    }, 100)
                    e.component.repaint()
                },
                onInitialized: e => {

                },
                scrollingEnabled: false
            }
        }

        jQuery.when.apply(jQuery,
            [Permissions.SCHEDULE_LIST, Permissions.ALARM_LIST]
                .map(p => Permissions.hasPermissions([p]))
        ).then((...permissions) => {
            this.permissions = permissions
            configureTabs(getTabs())
        })


        var listDataSource = [{ id: 1, text: 'Schedule', type: 1 }/*, { id: 2, text: 'Alarm', type: 2 }*/]

        $scope.configList = {
            selectionMode: 'single',
            dataSource: new DataSource({
                store: new ArrayStore({
                    key: "id",
                    data: listDataSource
                })
            }),
            onInitialized: e => {
                e.component.selectItem(listDataSource[0])
                this.configList = e.component
                changed(e.component.option('selectedItems')[0].type)
            },
            onSelectionChanged: e => {
                changed(e.addedItems[0].type)
            },
            bindingOptions: {
                selectedItemKeys: 'selectedConfigItem'
            },
            width: '250px'
        }

        var changed = (type: number) => {
            if (type == 1) {
                $scope.selectedConfig = 'schedule'
            }
            if (type == 2) {
                $scope.selectedConfig = 'alarm'
            }
        }

        $scope.$on(EventsNames.OPEN_DEVICE_CONFIGURATION + $scope.id, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.popupVisible = true
            $scope.selectedConfig = 'schedule'
            if (this.configList) this.configList.selectItem(listDataSource[0])

            $scope.idConfigurationProfile = args[0] || 0
            $timeout(() => {
                $scope.profileFunctionsList = args[1] || []
            })
        })

        $scope.$on(EventsNames.UPDATE_CONFIGURATION_PROFILE_FUNCTION_LIST, (event: ng.IAngularEvent, ...args: any[]) => {
            var configurationFunction: ScheduleConfigurationModel = args[0]

            if (configurationFunction.hourOfDay == 255)
                configurationFunction.hourOfDay = null

            var count = 0
            $scope.profileFunctionsList = $scope.profileFunctionsList.map(item => {
                if (item.indexNbr == configurationFunction.indexNbr) {
                    count++
                    return configurationFunction
                }
                return item
            })
            if (count == 0)
                $scope.profileFunctionsList.push(configurationFunction)
        })
    }]

    transclude = true
}